<template>
  <div class="quick-transform-edit">
    <component-graph-renderer ref='componentRenderer'
                            :transforms-and-source='transformsAndSource'
                            :transform='transform'
                            :parent-transform='parentTransform'
                            :partutil='partutil'
                            :treeutil='treeutil'
                            :initial-edit-component='initialEditComponent'
                            :child-component='childComponent'
                            :selection-first-mode='true'
                            class="h-32"
                            @remove='remove'
                            @preview='$emit("preview", $event)'
                            @edit='onEdit'
                            @add='add'>

        <!--
      <template #after='{component:viewComponent}'>
        <div>
          <recommender :gamedata='partutil.gamedata'
                              :partutil='partutil'
                              :component='viewComponent'
                              :transform='transform'
                              @add-recommendation='addRecommendation'
                              @add='add'
                              @preview='previewRecommender'
                              />
        </div>
      </template>
        -->

      <template #editing='data'>

        <portal to='after-graph'>
          
          <div class="overflow-x-scroll h-8">
            <quick-component :gamedata='partutil.gamedata'
                             :partutil='partutil'
                             :component='data.component'
                             :transform='transform'
                             :transforms-and-source='transformsAndSource'
                             @add-recommendation='addRecommendation'
                             @add='add'
                             @preview='previewRecommender'
                             @edit='onEdit({component:data.component,shadowComponent:data.shadowComponent})'
                             @change-component='$emit("change-component")'
                             :key='data.component.id'
                             class="overflow-x-scroll"
              />

          </div>
        </portal>

      </template>
  </component-graph-renderer>

  <portal-target name="after-graph" />

  <portal v-if='editingComponentDetails.id' to='component-edit-modal'>

    <pbc-modal title='' @done='doneEditing' @close='closeEditing'>
      <template #default=''>
        <component-details :component='shadowEditingComponentDetails'
                :transform='transform'
                :transforms-and-source='transformsAndSource'
                :partutil='partutil'
                :is-selected-component='true'
                @add='add'
                @remove='remove'>
          <template #recommend='{}'>
            <recommender-links :gamedata='partutil.gamedata'
                :partutil='partutil'
                :component='shadowEditingComponentDetails'
                :transform='transform'
                :short='true'
                @select='addLinkRecommendations({component:shadowEditingComponentDetails}, $event)'
                />
          </template>
        </component-details>

      </template>
      <template #controls='{close,done}'>
        <div class="py-3 w-full flex justiy-center inline-flex justify-center border-t border-solid border-grey-500">
          <pbc-button @click="done" ><check />Done</pbc-button>
          <pbc-button @click="preview({component:editingComponentDetails,shadowComponent:shadowEditingComponentDetails})" ><play />Preview</pbc-button>
        </div>
      </template>
    </pbc-modal>
  </portal>

  <!--
  <quick-animate :transform='transform'
                 :partutil='partutil'
                 :transforms-and-source='transformsAndSource' />
  -->


  </div>
</template>
<script>
import QuickComponent from '@ui/organisms/QuickComponent.vue';
import getChildComponent from '@edit/tree/funkies.js';
import RecommenderLinks from '@ui/organisms/RecommenderLinks.vue';
import Play from '@icons/Play.vue';
import Check from '@icons/Check.vue';
import Treeutil from '@edit/tree/treeutil.js';
import { cloneDeep, debounce, isEqual } from 'lodash';
import ComponentRenderer from '@edit/molecules/ComponentRenderer.vue';
import ComponentGraphRenderer from '@edit/organisms/ComponentGraphRenderer.vue';
import ComponentDetails from '@ui/molecules/ComponentDetails.vue';
import QuickAnimate from '@ui/organisms/QuickAnimate.vue';

export default {
  props: {
    transform: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    selectionsData:{
      type: Array,
      required: true
    },
    initialEditComponent: {
      type: Object,
      required: false
    },
    hasUndos: {
      type: Boolean,
      default: false
    },
    hasRedos: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onEdit({component,shadowComponent}) {
      this.editingComponentDetails = component;
      this.shadowEditingComponentDetails = shadowComponent;
    },
    addRecommendation({addedComponents, addedLinks}) {
      this.$emit('add-recommendation', {
        addedComponents,
        addedLinks
      });
      this.showPreviewButton = true;
      this.$ana.track({
        eventCategory:'recommendation',
        eventAction:'addRecommendation'
      });
      setTimeout( () => {
        this.$eventbus.emit('addRecommendation');
      }, 200);
    },
    preview({component,shadowComponent}) {
      Object.assign(component, shadowComponent);
      this.$emit('preview');
    },
    previewRecommender() {
      this.$emit('preview');
    },
    add({component}) {
      this.$ana.track({
        eventCategory:'ui',
        eventAction:'addComponent',
        extra: {
          parent: component.type
        }
      });

      const activeSelections = this.selectionsData.filter( (sd) => {
        return !sd.indirectlySelected;
      });

      if (activeSelections.length) {
        const transforms = activeSelections.map( ({transform}) => {
          return transform;
        });
        this.$emit('add-component', {
          parents: [component],
          transforms
        });
      }
      this.showPreviewButton = true;
    },
    remove({component}) {
      this.showPreviewButton = true;
      if (this.editingComponentDetails && this.editingComponentDetails.id === component.id) {
        this.editingComponent = null;
        this.editingComponentDetails = {};
        this.shadowEditingComponentDetails = {};
      }
      const {components,links} = this.transformsAndSource.from;
      const treeutil = new Treeutil({
        components,
        links
      });
      const {removedComponents, removedLinks} = treeutil.removeComponent(component);
      this.$emit('remove', {
        removedComponents,
        removedLinks,
      });
      //this._calculateComponentsAndLinks();
      
    },
    onChangeEditingComponent(component) {
      this.$emit("change-editing-component", component);
      this.editingComponent = component;
    },
    _calculateComponentsAndLinks() {
      const {components, links} = this.partutil.findComponentsAndLinksFrom(this.component);
      this.treeutil = new Treeutil({
        components,
        links
      });
      this.components = components;
      this.links = links;
    },
    forceSelectComponent({component}) {
      this.$refs.componentRenderer.select(component);
    },
    forceMoveToComponent({component}) {
      this.$refs.componentRenderer.moveTo({component});
    },
    closeEditing() {
      this.editingComponentDetails = {};
      this.shadowEditingComponentDetails = {};
    },
    doneEditing() {
      const component = this.editingComponentDetails;
      const shadowComponent = this.shadowEditingComponentDetails;
      const nv = cloneDeep(shadowComponent);
      const ov = cloneDeep(component);
      this.$emit('change', {
        nv,
        ov,
        transform:this.transform
      });

      Object.assign(component, shadowComponent);
      
      if (!isEqual(nv, ov)) {
        this.showPreviewButton = true;
      }

      this.editingComponentDetails = {};
      this.shadowEditingComponentDetails = {};
    },
    addLinkRecommendations({component}, link) {
      const addedComponents = [component]
      this.$emit('add-link-recommendation', {link,addedComponents});
      this.$refs.componentRenderer.moveTo({component});
      //moveTo({component});
    }
  },
  data() {
    const component = this.partutil.findComponentForTransform(this.transform);
    const calculateComponentsAndLinks = debounce(this._calculateComponentsAndLinks, 50);
    const {components, links} = this.partutil.findComponentsAndLinksFrom(component);
    const treeutil = new Treeutil({
      components,
      links
    });
    const parents = this.partutil.getParentsForTransform(this.transform);
    const parentTransform = parents[0];
    let childComponent;
    if (parentTransform) {
      const parentComponent = this.partutil.findComponentForTransform(parentTransform);
      childComponent = getChildComponent(parentComponent);
    }
    //const parentTransform = 
    return {
      component,
      treeutil,
      components,
      links,
      calculateComponentsAndLinks,
      editingComponent: null,
      showPreviewButton: false,
      parentTransform,
      childComponent,
      editingComponentDetails: {},
      shadowEditingComponentDetails: {}
    }
  },
  components:{
    //ComponentRenderer,
    ComponentGraphRenderer,
    ComponentDetails,
    Play,
    Check,
    QuickComponent
    //RecommenderLinks,
    //QuickAnimate
  },
  watch: {
    'transformsAndSource.from.links.length': {
      handler() {
        this.calculateComponentsAndLinks();
      },
      immediate: true
    },
    'transformsAndSource.from.components.length': {
      handler() {
        this.calculateComponentsAndLinks();
      },
      immediate: true
    },
    'transform.vars':{
      handler() {
        this.showPreviewButton = true;
      },
      deep: true
    },
    shadowEditingComponentDetails: {
      handler(nv) {
        this.$emit("change-component");
      },
      deep: true
    }
  },
  beforeDestroy() {
    this.$emit("change-editing-component", null);
  }
}
</script>
